import script from "./ViewReportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewReportModal.vue?vue&type=script&setup=true&lang=js"

import "./ViewReportModal.vue?vue&type=style&index=0&id=6f8b70c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f8b70c6"]])

export default __exports__